// Seitenkontext-Helfer.
//
// Der Core vergibt body.home nicht nur an die echte Startseite: Detailansichten
// von Kollektionen (z. B. ein alfer-Insights-Beitrag) werden im Kontext der
// Sprach-Startseite aufgeloest und erben deren Body-Klassen. Sie tragen
// zusaetzlich isFullView.
//
// Alles, was am Startseiten-Hero haengt (Header-Animation, Reveal-Gating der
// sticky Kontaktbox), muss deshalb ueber isHomepage() gehen statt direkt
// body.home abzufragen - sonst laeuft die Hero-Animation auch auf
// Detailseiten los.

export function isHomepage() {
  const { classList } = document.body;
  return classList.contains('home') && !classList.contains('isFullView');
}
